<template>
    <div id="app" :class="appClass">
        <VersionInfo v-if="getVersion && getEnvironment.length > 0" :version="getVersion" :compilations="getCompilations" :environment="getEnvironment"></VersionInfo>
        <transition name="fade">
            <router-view />
        </transition>
        <Toast />
    </div>
</template>

<script>
    import Toast from 'primevue/toast';
    import VersionInfo from 'myra-ui-common/components/header/VersionInfo';
    import { mapGetters } from 'vuex'

    export default {
        components : {
            Toast,
            VersionInfo
        },
        computed : {
            ...mapGetters(['getVersion', 'getEnvironment', 'getCompilations']),
            isLoggedIn() {
                return this.$store.getters.isLoggedIn;
            },
            user() {
                return this.$store.getters.getLoggedUser;
            },
            userMenu() {
                const self = this;
                return [
                    {
                        label   : this.$i18n.t('header.menu.view'),
                        command : () => {
                            self.$router.push({
                                name   : 'user',
                                params : { userId : self.user.id },
                            });
                        },
                    },
                    {
                        label   : this.$i18n.t('header.menu.logout'),
                        command : () => {
                            self.$router.push({ name : 'logout' });
                        },
                    },
                ];
            },
            appClass() {
                return this.isLoggedIn ? 'app' : 'login';
            },
            isAgentMode() {
                return this.$store.getters.isAgentMode;
            },
        },

        watch : {
            $route(to) {
                const title = to.meta.title || 'route.meta.default.title';
                document.title = this.$i18n.t(title);
            },
        },
        beforeCreate : function () {
            this.$store.dispatch('init');
            this.$store.dispatch('loadVersionInfo');
            this.$localStorage.set('context', 'start');
            this.$eventBus.$on('token-expired', () => {
                this.$notifier.notifyWarning(
                    this.$i18n.t('common.messages.sessionExpired')
                );
                // logout and redirect to the login page
                this.$store
                    .dispatch('logout')
                    .then(() => this.$router.push({ name : 'login' }));
            });
            this.$eventBus.$on('unauthorized', () => {
                this.$store
                    .dispatch('logout')
                    .then(() => this.$router.push({ name : 'login' }));
            });
        },
    };
</script>

<style lang="scss">
    @import '~myra-ui-lib/style/prime';
    @import '~myra-ui-lib/style/main';
</style>

<i18n src="myra-ui-common/i18n/common.json" />
<i18n src="src/i18n/routes.json" />
